import { render } from "./PageKaizenList_v3.vue?vue&type=template&id=d6144812&scoped=true&ts=true"
import script from "./PageKaizenList_v3.vue?vue&type=script&lang=ts"
export * from "./PageKaizenList_v3.vue?vue&type=script&lang=ts"

import "./PageKaizenList_v3.vue?vue&type=style&index=0&id=d6144812&scoped=true&lang=css"

import exportComponent from "D:\\project\\CDM_QR-Access-Control-System-3\\DoorWebApp_Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6144812"]])

export default __exports__